<colgroup></colgroup>
@for (
  column of multiMatrixQuestion.columns;
  track columnIndex;
  let columnIndex = $index
) {
  <colgroup
    [span]="
      (column.rows[0].type === 'SINGLE_CHOICE' &&
        column.rows[0].presentation !== 'DROPDOWN') ||
      column.rows[0].type === 'MULTIPLE_CHOICE'
        ? column.rows[0].alternatives.length
        : 1
    "
    [ngClass]="{ 'border-l border-l-gray-500': columnIndex === 1 }"
  ></colgroup>
}
<thead>
  <tr>
    <th
      rowspan="2"
      class="left-0 min-w-24"
      [id]="idPrefix + 'corner-' + multiMatrixQuestion.id"
      aria-hidden="true"
    ></th>
    @for (
      column of multiMatrixQuestion.columns;
      track columnIndex;
      let columnIndex = $index
    ) {
      <th
        scope="colgroup"
        [id]="
          idPrefix +
          (column.title | toValidId) +
          '-' +
          multiMatrixQuestion.id
        "
        [colSpan]="
          (column.rows[0].type === 'SINGLE_CHOICE' &&
            column.rows[0].presentation !== 'DROPDOWN') ||
          column.rows[0].type === 'MULTIPLE_CHOICE'
            ? column.rows[0].alternatives.length
            : 1
        "
        [class.second-column-start]="columnIndex === 1"
      >
        @if (!column.hideTitle) {
          <span [innerHTML]="column.title | safeHtml"></span>
        }
      </th>
    }
  </tr>
  <tr class="align-bottom">
    @for (
      column of multiMatrixQuestion.columns;
      track columnIndex;
      let columnIndex = $index
    ) {
      @if (
        column.rows[0].presentation === "VERTICAL" ||
        column.rows[0].presentation === "HORIZONTAL"
      ) {
        @if (
          column.rows[0].type === "SINGLE_CHOICE" ||
          column.rows[0].type === "MULTIPLE_CHOICE"
        ) {
          @for (
            alternative of column.rows[0].alternatives;
            track altIndex;
            let altIndex = $index
          ) {
            <th
              class="px-1 text-wrap"
              scope="col"
              [class.second-column-start]="columnIndex === 1 && altIndex === 0"
              [style.width]="
                getColumnWidth(
                  column.rows[0].alternatives.length,
                  column.rows[0].alternatives,
                  column.rows[0].id
                )
              "
              [style.min-width]="
                getColumnMinWidth(alternative.title, column.rows[0].id)
              "
            [id]="
              idPrefix +
              (alternative.title | toValidId) +
              '-' +
              multiMatrixQuestion.id
            "
          >
              <div class="inline-block">
                @if (alternative.image) {
                  <img
                    [src]="alternative.image.url"
                    [alt]="alternative.image.alternateText || alternative.title"
                    [style.width.px]="alternative.image.width"
                    [style.height.px]="alternative.image.height"
                    [style.object-fit]="'fill'"
                    [style.display]="'block'"
                  />
                }
                @if (!alternative.image?.hideTitle) {
                  <span [innerHTML]="alternative.title | safeHtml"></span>
                }
              </div>
            </th>
          }
        }
      } @else if (
        column.rows[0].presentation === "DROPDOWN" ||
        column.rows[0].presentation === "SINGLE_LINE"
      ) {
        <th
          class="px-1"
          aria-hidden="true"
          [class.second-column-start]="columnIndex === 1"
          [id]="idPrefix + 'empty-header-' + multiMatrixQuestion.id"
        ></th>
      } @else {
        @if (
          column.rows[0].type === "SINGLE_CHOICE" ||
          column.rows[0].type === "MULTIPLE_CHOICE"
        ) {
          @for (
            alternative of column.rows[0].alternatives;
            track altIndex;
            let altIndex = $index
          ) {
          <th
            class="px-1"
            scope="col"
            [class.second-column-start]="columnIndex === 1 && altIndex === 0"
            [id]="
              idPrefix +
              (alternative.title | toValidId) +
              '-' +
              multiMatrixQuestion.id
            "
          ></th>
          }
        }
      }
    }
  </tr>
</thead>
